// extracted by mini-css-extract-plugin
export default {"emailBoxContainer":"EmailBox_emailBoxContainer__SM15H","emailBox":"EmailBox_emailBox__aIkyQ"};